import React, {useEffect} from 'react';
import {Button, Container} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import {getTripById} from "../redux/actions/tripActions";
import TripHead from "../components/Booking/SelectRoom/TripHead";
import BookingStepper from "../components/Booking/BookingStepper";
import TripInfo from "../components/Booking/SelectRoom/TripInfo";
import SelectRoom from "../components/Booking/SelectRoom/SelectRoom";
import SummaryContainer from "../components/Booking/Summary/SummaryContainer";
import {setStep} from "../redux/actions/stepActions";
import Grid from "@mui/material/Grid";
import {setTripId} from "../redux/actions/transactionActions";
import {getStepFromUrl, registerFindTrip, restartBooking, isWidget} from "../utils/utils";
import GuestBar from "../components/GuestInfo/GuestBar";
import {useIsAuthenticated} from "react-auth-kit";
import Typography from "@mui/material/Typography";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes";
import TripSummary from "../components/Booking/Summary/TripSummary";
import ObserverDimensions from "../components/ObserverDimensions";

const SelectRoomPage = () => {
    const dispatch = useDispatch();
    const {id} = useParams();
    const {data: trip} = useSelector(state => state.trip);
    const rooms = useSelector(state => state.rooms);
    const {tripId} = useSelector(state => state.transactions);
    const isAuth = useIsAuthenticated();
    const history = useHistory();

    const validateTransactions = () => {
        if (sessionStorage.getItem('transactions')) {
            const transactions = JSON.parse(sessionStorage.getItem('transactions'))
            if (parseInt(transactions.tripId) !== parseInt(id))
                restartBooking(id);
        }
    };

    useEffect(() => {
        validateTransactions();
        const stepNum = getStepFromUrl(history.location.pathname);
        dispatch(setStep(stepNum));
        registerFindTrip();
    }, []);

    useEffect(() => {
        if (trip?.TripId !== parseInt(id))
            dispatch(getTripById(id));

        if (trip?.TripId && trip.TripId !== tripId)
            dispatch(setTripId(trip.TripId));

        if (trip)
            verifyVisibility();

    }, [trip?.TripId]);

    const handleWait = () => {
        history.push(`/booking/${tripId}/wait-list`);
    };

    const verifyVisibility = () => {
        switch (trip?.visible) {
            case -1:
                return history.push(`/booking/${tripId}/inquiry`);
            case 0:
            case -4:
            case -5:
                return history.push("/");
            default:
                break;
        }
    };

    return (
        <div>
            {isAuth() && <GuestBar/>}
            {trip && Object.keys(trip).length > 0 && <>
                {!isWidget() && <TripHead/>}
                <Container maxWidth="lg">
                    <BookingStepper/>
                    <TripInfo/>
                    <div style={{marginTop: 50}}/>
                    {rooms.length > 0 && (
                        <Grid container spacing={3} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                            <Grid item xs={12} sm={12} md={9}>
                                {parseInt(trip.available) === 0 &&
                                    <Typography sx={{paddingTop: 5, paddingBottom: 5}} variant="h4" component="h4"
                                                className={'tripTitle'}>
                                        Sorry, this trip no longer has spaces available, please request to be added to
                                        the waiting list or contact our office to provide you a special service
                                    </Typography>}
                                {parseInt(trip.available) > 0 && <SelectRoom/>}
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                {parseInt(trip.available) === 0 &&
                                    <Button color={'primary'} variant={'contained'} fullWidth onClick={handleWait}>
                                        Add me to Wait List
                                    </Button>}
                                {parseInt(trip.available) > 0 && <SummaryContainer/>}
								{isWidget() && <TripSummary/>}
                            </Grid>
                        </Grid>
                    )}
                </Container>
            </>}
            {isWidget() && <ObserverDimensions/>}
        </div>
    );
};

export default SelectRoomPage;

SelectRoomPage.propTypes = {
    trip: TripPropTypes,
};
